import {
  commonPagesConstants,
  curBookingsConstants,
} from 'store/constants';
import {
  BookingI,
  WorkingBookingI,
} from 'store/models/bookings/Booking';
import {
  EachFileSelected,
  EachPage,
} from 'store/models/file-selected/file-selected.interface';

/**
 * include global common
 */

const initialState = {
  viewingIndex: null as null | number,
  bookings: [] as BookingI[],
  commonPages: [] as EachPage[],
};

/**
 * current ticket bookings
 * @param state
 * @param action
 */
export const curBookings = (
  state = initialState,
  action: {
    type: string;
    payload: {
      bookingNo?: string;
      bookings?:
        | (BookingI | WorkingBookingI)[]
        | { bookings: BookingI[]; viewingIndex: number };
      index?: number;
      fileSelected?: EachFileSelected[];
      commonPages?: EachPage[];
    };
  },
) => {
  const { bookings: bookingsInput, index, fileSelected } =
    action.payload || {};

  // catch some wrong autosave case (i.e. saved the whole curBookings from store)
  let bookings = bookingsInput as BookingI[];
  if (
    bookingsInput &&
    !Array.isArray(bookingsInput) &&
    Array.isArray(bookingsInput.bookings)
  ) {
    bookings = bookingsInput.bookings;
  }

  const { viewingIndex } = state;
  switch (action.type) {
    case commonPagesConstants.SET_COMMON_PAGES:
      if (!action.payload.commonPages)
        throw Error(`payload.commonPages is missing`);
      return {
        ...state,
        commonPages: action.payload.commonPages,
      };
    case curBookingsConstants.UPDATE_BOOKING_NO_AT_INDEX:
      return {
        ...state,
        bookings: state.bookings.map((b, i) =>
          i !== action.payload.index
            ? b
            : {
                ...b,
                bookingNo: action.payload.bookingNo,
              },
        ),
      };
    case curBookingsConstants.SET_VIEWING_INDEX:
      return {
        ...state,
        viewingIndex: index,
      };
    case curBookingsConstants.INIT_COMMON_PAGES:
      return {
        ...state,
        commonPages: action.payload.commonPages || [],
      };
    case curBookingsConstants.INIT_CUR_BOOKINGS:
      return {
        ...state,
        bookings: (bookings as WorkingBookingI[]).map((b) => ({
          ...b,
          isSelected: b.isSelected ?? false,
          fileSelected: b.fileSelected || [],
        })),
      };
    case curBookingsConstants.RESET:
      return initialState;
    case curBookingsConstants.SET_CUR_BOOKINGS:
      return { ...state, bookings };
    case curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX:
      // also update booking's file selected at viewing index if fileSelected is updated
      if (viewingIndex === undefined)
        throw Error(`viewingIndex is undefined`);
      console.debug(
        `state.bookings `,
        state.bookings,
        'fileSelected',
        fileSelected,
        state.bookings.map((b: BookingI, i) =>
          i !== viewingIndex ? b : { ...b, fileSelected },
        ),
        'viewingIndex',
        viewingIndex,
      );
      return {
        ...state,
        bookings: state.bookings.map((b: BookingI, i) =>
          i !== viewingIndex ? b : { ...b, fileSelected },
        ),
      };
    case curBookingsConstants.RESET_FILE_SELECTED_AT_VIEWING_INDEX:
      if (viewingIndex === undefined)
        throw Error(`viewingIndex is undefined`);
      return {
        ...state,
        bookings: state.bookings.map((b: BookingI, i) =>
          i !== viewingIndex ? b : { ...b, fileSelected: [] },
        ),
      };
    default:
      return state;
  }
};
